import { render, staticRenderFns } from "./SearchScopeSelector.vue?vue&type=template&id=1fd9d1c6&scoped=true"
import script from "./SearchScopeSelector.vue?vue&type=script&lang=js"
export * from "./SearchScopeSelector.vue?vue&type=script&lang=js"
import style0 from "./SearchScopeSelector.vue?vue&type=style&index=0&id=1fd9d1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9d1c6",
  null
  
)

export default component.exports